import React, { useEffect } from "react";
import { Box, Avatar, Typography, TextField } from "@mui/material";
import Icon1 from "../icons/Icon";
import { useTheme } from "@mui/material";
import SecondaryButton from "../buttons/SecondaryButton";
import { BorderAllRounded } from "@mui/icons-material";
import Divider from "../layout/Divider";
import TextField2 from "../textfields/TextField2";
import TextField1 from "../textfields/PasswordField";
import TextFieldSearch from "../textfields/TextFieldSearch";
import TextFieldBorderLess from "../textfields/TextFieldBorderLess";
import TextFieldChat from "../textfields/TextFieldChat";
import {
  getArrayDocDataByID,
  getArrayDocDataByRef,
  getArrayDocRefByIDs,
  getDocDataById,
  getDocDataByRef,
  getRefFromId,
  updateDocDataField,
  getFlutterTime,
} from "../models/DataFunctions";
import { use } from "echarts";
import {
  getCurrentUser,
  getOrRefreshFirebaseToken,
} from "../config/getFirebaseToken";
import sendChatMessage from "../api/send/sendChatMessage";
import { useSnackbar } from "notistack";
import { useRef } from "react";
import deleteMessage from "../api/delete/deleteMessage";
import sendFileF from "../api/send/sendFileF";
import sendImageF from "../api/send/sendImageF";
import downloadImage from "../api/download/downloadImage";
import downloadFile from "../api/download/downloadFile";
import sendFileFU from "../api/send/sendFileFU";
import { useAppContext } from "../config/AppContext";
import PrimaryButton from "../buttons/PrimaryButton";
import { useState } from "react";
import updateDocDataFieldApi from "../api/database/updateDocDataFieldApi";
import SmallSpinner from "../loading/SmallSpinner";
import Tippy from "@tippyjs/react";
import { useNavigate } from "react-router-dom";
import { Spin } from "antd";
import { isFolderClient, isFolderMaster } from "../hexagone/VisibilityHelpers";
import { getOrgById } from "../models/OrgFunctions";
import { ChatApp } from "../config/FirebaseNotificationSystem";
import { getIdToken } from "firebase/auth";

const FolderChat = ({
  folder,
  messages = [],
  orgData,
  userData,
  onUpdate,
  dragging,
  uploadedlist = [],
  resetDroppedFiles,
  can_go_folder = false,
  sendDrop,
  navigateWorkspace,
  workspaceData,
}) => {
  const theme = useTheme();
  const [orgNamesMap, setOrgNamesMap] = React.useState({});
  const orgNamesCacheRef = useRef({});
  const [message_value = "", setMessageValue] = React.useState("");
  const [messageNotRead, setMessageNotRead] = React.useState(true);
  const [master_id, setMaster_id] = React.useState("");
  const [readByNames, setReadByNames] = React.useState({});

  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;

  const [loadingComplex, setLoadingComplex] = useState(false);

  const [receiver_options, setReceiverOptions] = useState([]);
  const [messageAdmin, setMessageAdmin] = useState(false);
  const [receiver, setReceiver] = useState(null);

  const [loading_sending, setLoadingSending] = useState(false);

  const handleFetchData = async () => {
    console.log("orgData", orgData);

    const master_id = folder.master_id;
    const client_ref = folder.client_id;
    setMaster_id(master_id);

    let use = getCurrentUser();

    // const chatApp = new ChatApp();
    // chatApp.init(use.uid, prefix, false);

    // // Store reference if needed
    // window.chatApp = chatApp;

    let master = await getOrgById(folder.master_id);
    let partners =
      (await getArrayDocDataByID("org", folder.partners_id || [])) || [];
    let receiver_options;
    if (folder.client_type !== "particulier") {
      let client = await getOrgById(folder.client_id);

      receiver_options = [
        {
          name: "Tous",
          value: "Tous",
        },
        {
          name: master.name,
          value: master.id,
        },
        {
          name: client.name,
          value: client.id,
        },
      ];
      if (orgData?.id === folder.master_id && !receiver) {
        setReceiver({
          name: client.name,
          value: client.id,
        });
      }
    } else {
      receiver_options = [
        {
          name: "Tous",
          value: "Tous",
        },
        {
          name: master.name,
          value: master.id,
        },
        {
          name: "Particulier",
          value: "particulier",
        },
      ];

      if (orgData?.id === folder.master_id && !receiver) {
        setReceiver({
          name: "Particulier",
          value: "particulier",
        });
      } else {
        if (orgData?.id !== folder.master_id && !receiver) {
          setReceiver({
            name: master.name,
            value: master.id,
          });
        }
      }
    }
    for (const partner of partners) {
      receiver_options.push({
        name: partner.name,
        value: partner.id,
      });
    }
    setReceiverOptions(receiver_options);

    if (!isFolderMaster(orgData, folder) && !receiver) {
      setReceiver({
        name: master.name,
        value: master.id,
      });
    }
    setMessageNotRead(true);
    console.log("receiver_options:", receiver_options);
  };
  console.log("receiver:", receiver);
  const handleGoFolder = () => {
    navigateWorkspace(`/folder/${folder.id}`);
  };

  const handleGetAuthorNames = async () => {
    const unknownIds = new Set();
    for (const message of messages) {
      if (message.author_id && !orgNamesCacheRef.current[message.author_id]) {
        unknownIds.add(message.author_id);
      }
    }

    if (unknownIds.size > 0) {
      const orgs = await getArrayDocDataByID("org", [...unknownIds]);
      for (const org of orgs) {
        if (org) {
          orgNamesCacheRef.current[org.id] = org.name || "Inconnu";
        }
      }
      for (const id of unknownIds) {
        if (!orgNamesCacheRef.current[id]) {
          orgNamesCacheRef.current[id] = "Inconnu";
        }
      }
    }

    setOrgNamesMap({ ...orgNamesCacheRef.current });

    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop =
        chatContainerRef.current.scrollHeight;
    }
  };

  const handleSendFile = async () => {
    setLoadingComplex(true);
    const token = await getOrRefreshFirebaseToken();
    const folderconvRef = folder.folderconv;
    let uploadState;
    uploadState = await sendFileF(
      token,
      folderconvRef,
      "chargement ...",
      receiver,
      folder.id,
      orgData?.ref || getRefFromId("org", "particulier"),
      prefix
    );
    if (uploadState == "uploaded") {
      handleClickVariant("Fichier envoyé", "success");
    } else if (uploadState == "not uploaded") {
      handleClickVariant("Erreur lors de l'envoi du fichier", "error");
    } else if (uploadState == "no file") {
      handleClickVariant("Aucun fichier sélectionné", "error");
    }
    await onUpdate();
    setLoadingComplex(false);
  };

  const handleSendImage = async () => {
    setLoadingComplex(true);
    const token = await getOrRefreshFirebaseToken();
    const folderconvRef = folder.folderconv;
    await sendImageF(
      token,
      folderconvRef,
      "chargement ...",
      receiver,
      folder.id,
      orgData?.ref || getRefFromId("org", "particulier"),
      prefix
    );
    handleClickVariant("Image envoyée", "success");
    await onUpdate();
    setLoadingComplex(false);
  };

  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };

  const handleDownloadImage = async (message) => {
    await downloadImage(message.img_file);
    handleClickVariant("Téléchargement en cours", "success");
  };

  const [loadingDownloadFile, setLoadingDownloadFile] = useState(null);
  const handleDownloadFile = async (message) => {
    setLoadingDownloadFile(message.id);
    if (message.file?.url) {
      if (!message.file.url.includes(".pdf")) {
        await downloadImage(message.file);
      } else {
        await downloadFile(message.file);
      }
    } else if (message.img_file?.url) {
      await downloadImage(message.img_file);
    }
    handleClickVariant("Téléchargement en cours", "success");
    setLoadingDownloadFile(null);
  };

  const handleSendDropZoneFile = async (message) => {
    if (message.file?.url) {
      await sendDrop(message.file);
    }
    handleClickVariant("Fichier envoyé dans la DropZone", "success");
  };

  const handleDeleteMessage = async (message) => {
    const token = await getOrRefreshFirebaseToken();
    await deleteMessage(message.id, folder.id, token, prefix);
    handleClickVariant("Message supprimé", "success");
    onUpdate();
  };

  const handleSetMessagesRead = async () => {
    const token = await getOrRefreshFirebaseToken();
    const notified_orgs_id = folder.notified_orgs_id || [];
    const new_notified_orgs = notified_orgs_id.filter(
      (org_id) => org_id !== (orgData?.id || "particulier") && org_id !== null
    );
    await updateDocDataFieldApi(
      folder.ref,
      "notified_orgs_id",
      new_notified_orgs,
      prefix
    );

    // Mark the current timestamp as the last read time for this org
    const last_read_by = folder.last_read_by || {};
    last_read_by[orgData?.id || "particulier"] = getFlutterTime();
    console.log("last_read_by to set:", last_read_by);
    await updateDocDataFieldApi(
      folder.ref,
      "last_read_by",
      last_read_by,
      prefix
    );

    setMessageNotRead(false);
    handleClickVariant("Messages marqués comme lus", "success");
    onUpdate();
  };

  const handleSendFileFU = async () => {
    const token = await getOrRefreshFirebaseToken();
    const folderconvRef = folder.folderconv;

    await sendFileFU(
      uploadedlist,
      orgData?.id || "particulier",
      token,
      folderconvRef,
      "chargement ...",
      orgData?.ref || getRefFromId("org", "particulier"),
      folder.id,
      prefix
    );
    handleClickVariant("Fichier envoyé", "success");
    onUpdate();
    resetDroppedFiles();
  };

  const handleSetOption = (value) => {
    // I want to set message.receiver
    let recevier = receiver_options.find((option) => option.value === value);
    setReceiver(recevier);
    // remove the @ from the message_value
    if (message_value.startsWith("@")) {
      setMessageValue(message_value.substring(1));
    }
  };

  function getTimeString(post_seconds) {
    let seconds = Math.floor(Date.now() / 1000) - post_seconds;
    const intervals = [
      { label: "an", seconds: 31536000 },
      { label: "mois", seconds: 2592000 },
      { label: "jour", seconds: 86400 },
      { label: "heure", seconds: 3600 },
      { label: "minute", seconds: 60 },
      { label: "seconde", seconds: 1 },
    ];

    const timeAgo = intervals.find((i) => seconds >= i.seconds) || intervals[5];
    const count = Math.floor(seconds / timeAgo.seconds);

    return `Il y a ${count} ${timeAgo.label}${count > 1 && timeAgo.label !== "mois" ? "s" : ""}`;
  }

  const handleSendMessage = async () => {
    setLoadingComplex(true);
    if (orgData?.id === folder.master_id) {
      setLoadingSending(true);
    }
    const token = await getOrRefreshFirebaseToken();

    const org_id = orgData?.id || "particulier";
    const folder_id = folder.id;
    const folderconv_id = folder.folderconv.id;
    const message_value2 = message_value;

    await sendChatMessage(
      org_id,
      folder_id,
      folderconv_id,
      message_value2,
      receiver,
      token,
      prefix
    );
    handleClickVariant("Message envoyé", "success");
    await onUpdate();
    // onUpdate();
    setMessageValue(""); // wait 2 seconds

    let users = await getArrayDocDataByID("user", orgData.users_id || []);
    let admin = users.find((user) => user.org_admin);

    let people_to_notify_id = [];
    if (folder.assistants_id) {
      people_to_notify_id = [...folder.assistants_id];
    }
    if (folder.members_id) {
      people_to_notify_id = [...people_to_notify_id, ...folder.members_id];
    }
    if (people_to_notify_id.length === 0 && admin) {
      people_to_notify_id = [admin.id];
    }

    if (window.chatApp) {
      for (const user_id of people_to_notify_id) {
        window.chatApp.sendMessage(
          user_id,
          userData?.id || getCurrentUser()?.id || "",
          "Nouveau message " + folder.nom,
          message_value,
          folder.id,
          prefix,
          workspaceData
        );
      }
    }

    setLoadingSending(false);

    setLoadingComplex(false);
  };
  const [initialised, setInitialised] = useState(false);

  useEffect(() => {
    console.log("FolderChat useEffect folder or userData changed", folder);
    if (folder && !initialised) {
      setInitialised(true);
      handleFetchData();
    }
  }, [folder]);

  useEffect(() => {
    handleGetAuthorNames();
    fetchReadByNames();
  }, [messages, folder]);

  const getOrgName = (authorId) => {
    if (!authorId) return "Inconnu";
    return orgNamesMap[authorId] || "...";
  };

  const getReadByOrgs = (message, includeLastReadOnly = false) => {
    if (!folder.last_read_by || !message.post_date) return [];

    const messageTimestamp = message.post_date.seconds * 1000;
    const readByOrgs = [];

    for (const [orgId, readTime] of Object.entries(folder.last_read_by)) {
      let readTimestamp;
      if (readTime.seconds) {
        readTimestamp = readTime.seconds * 1000;
      } else if (readTime instanceof Date) {
        readTimestamp = readTime.getTime();
      } else {
        readTimestamp = new Date(readTime).getTime();
      }

      if (orgId !== message.author_id) {
        if (includeLastReadOnly) {
          // Only include if this is the last message before the read timestamp
          const nextMessage =
            messages[messages.findIndex((m) => m.id === message.id) + 1];
          const isLastReadMessage =
            readTimestamp >= messageTimestamp &&
            (!nextMessage ||
              nextMessage.post_date.seconds * 1000 > readTimestamp);

          if (isLastReadMessage) {
            readByOrgs.push({ orgId, readTime });
          }
        } else {
          if (readTimestamp >= messageTimestamp) {
            readByOrgs.push({ orgId, readTime });
          }
        }
      }
    }

    return readByOrgs;
  };

  const fetchReadByNames = async () => {
    if (!folder.last_read_by) return;

    const unknownIds = [];
    const namesMap = {};
    for (const orgId of Object.keys(folder.last_read_by)) {
      if (orgId === "particulier") {
        namesMap[orgId] = "Particulier";
      } else if (orgNamesCacheRef.current[orgId]) {
        namesMap[orgId] = orgNamesCacheRef.current[orgId];
      } else {
        unknownIds.push(orgId);
      }
    }

    if (unknownIds.length > 0) {
      const orgs = await getArrayDocDataByID("org", unknownIds);
      for (const org of orgs) {
        if (org) {
          namesMap[org.id] = org.name || "Inconnu";
          orgNamesCacheRef.current[org.id] = org.name || "Inconnu";
        }
      }
      for (const id of unknownIds) {
        if (!namesMap[id]) namesMap[id] = "Inconnu";
      }
    }

    setReadByNames(namesMap);
  };

  const formatReadTime = (readTime) => {
    let timestamp;
    if (readTime.seconds) {
      timestamp = readTime.seconds;
    } else if (readTime instanceof Date) {
      timestamp = Math.floor(readTime.getTime() / 1000);
    } else {
      timestamp = Math.floor(new Date(readTime).getTime() / 1000);
    }
    return getTimeString(timestamp);
  };

  const chatContainerRef = useRef(null);

  return (
    <div className="h-full w-full  flex flex-col gap-2  ">
      <div
        className={`relative ${can_go_folder ? "h-full" : "h-c500"} rounded-xl bg-neutral-100  pb-28  flex flex-col `}
      >
        <div
          className=" w-full overflow-y-auto   flex flex-col  gap-5  h-full"
          ref={chatContainerRef}
        >
          {loadingComplex && (
            <div className="flex flex-col justify-center h-full w-full gap-2  px-2 text-h3 items-center text-shadow_50">
              <SmallSpinner />
            </div>
          )}

          <div className="px-2 pt-2 pb-20">
            {!loadingComplex &&
              messages.map((message, index) => (
                <div key={index}>
                  <div className="">
                    <div className="text-h4 text-shadow_25 ">
                      {messageAdmin && message.id}
                    </div>

                    {message.author_id === (orgData?.id || "particulier") ? (
                      <div
                        className="text-shadow_50 group text-h3 flex flex-col  w-full text-right"
                        key={index}
                      >
                        {message.file?.url ? (
                          <div
                            onClick={() => handleDownloadFile(message)}
                            className="flex flex-row gap-2 ml-auto   max-w-60   cursor-pointer  text-violet-500 rounded-md  w-fit "
                          >
                            <Tippy
                              content="Télécharger le fichier"
                              className="custom-tooltip"
                              delay={500}
                            >
                              <div className="flex flex-col">
                                <div className="text-h3 flex flex-row justify-center items-center gap-3 hover:font-medium text-wrap text-indigo-500 bg-indigo-100 rounded-xl p-3">
                                  {loadingDownloadFile === message.id ? (
                                    <SmallSpinner></SmallSpinner>
                                  ) : (
                                    <Icon1
                                      icon_name="file"
                                      fill="#6366f1"
                                      size={25}
                                    ></Icon1>
                                  )}

                                  <div className="flex flex-col justify-start items-start">
                                    <div className="text-h3">
                                      {message.file?.name.length > 20
                                        ? message.file?.name.substring(0, 20) +
                                          "..."
                                        : message.file?.name}
                                    </div>
                                    <div className="text-h5 text-shadow_50">
                                      {
                                        // file size in kB
                                        Math.round(message.file?.octets / 1000)
                                      }{" "}
                                      Ko
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Tippy>
                          </div>
                        ) : message.img_file?.url ? (
                          <div
                            onClick={() => handleDownloadFile(message)}
                            className="flex relative flex-row gap-2 ml-auto cursor-pointer max-w-60 p-2 hover:max-w-full duration-1000 transition-all  w-fit  rounded-tr-none "
                          >
                            {loadingDownloadFile === message.id && (
                              <div className="absolute top-4  left-4 z-10 p-2 bg-shadow_25 backdrop-blur-md border-wshadow_50 border-1 rounded-md">
                                <SmallSpinner></SmallSpinner>
                              </div>
                            )}
                            <Tippy
                              content="Télécharger l'image"
                              className="custom-tooltip"
                              delay={500}
                            >
                              <div className="flex flex-col">
                                <img
                                  src={message.img_file.url}
                                  className=" max-h-c150  min-w-full rounded-xl hover:max-h-full duration-1000 transition-all"
                                ></img>
                              </div>
                            </Tippy>
                          </div>
                        ) : (
                          <div
                            className={`flex flex-row gap-2 ml-auto text-left ${can_go_folder ? "max-w-c500" : "max-w-60"} min-w-0 p-3 bg-black text-white rounded-3xl w-fit rounded-tr-none`}
                          >
                            <div className="flex flex-col min-w-0">
                              <div
                                className="text-h3 text-wrap whitespace-pre-wrap break-words"
                                style={{
                                  overflowWrap: "anywhere",
                                  wordBreak: "break-word",
                                }}
                              >
                                {message.content}
                              </div>
                            </div>
                          </div>
                        )}
                        <div className="flex flex-row gap-2 text-h5 w-fit ml-auto text-right scale-0 p-0 group-hover:p-1  opacity-0  pointer-events-none transition-all duration-300 group-hover:opacity-100 group-hover:scale-100 group-hover:pointer-events-auto">
                          {
                            <div className="flex flex-row gap-2">
                              <div>
                                {getOrgName(message.author_id) === orgData?.name
                                  ? ""
                                  : getOrgName(message.author_id)}
                              </div>{" "}
                              <div className="text-shadow_50 flex">
                                {message.sender_user_name || "Inconnu"}
                              </div>
                              <div className="text-shadow_50  ">
                                {"à " + (message.receiver?.name || "Inconnu")}
                              </div>
                            </div>
                          }

                          <div className="text-shadow_50">
                            {getTimeString(message.post_date.seconds)}
                          </div>
                          <Tippy
                            content="Supprimer le message"
                            className="custom-tooltip"
                            delay={500}
                          >
                            <div
                              onClick={() => handleDeleteMessage(message)}
                              className="cursor-pointer"
                            >
                              <Icon1
                                icon_name="delete"
                                height="16px"
                                width="16px"
                                fill="grey"
                              ></Icon1>
                            </div>
                          </Tippy>
                          {!can_go_folder && (
                            <div
                              onClick={() => handleSendDropZoneFile(message)}
                              className="cursor-pointer"
                            >
                              {message.file?.url && (
                                <Icon1
                                  icon_name="cloud"
                                  height="16px"
                                  width="16px"
                                  fill="grey"
                                ></Icon1>
                              )}
                            </div>
                          )}
                        </div>
                        {(() => {
                          const readByOrgs = getReadByOrgs(message, true);
                          if (readByOrgs.length > 0) {
                            return (
                              <div className="text-h5 text-shadow_50 ml-auto text-right mt-1">
                                Lu par:{" "}
                                {readByOrgs
                                  .map(
                                    (item) =>
                                      `${readByNames[item.orgId] || "..."} (${formatReadTime(item.readTime)})`
                                  )
                                  .join(", ")}
                              </div>
                            );
                          }
                          return null;
                        })()}
                      </div>
                    ) : !message.receiver ||
                      message.receiver?.name === "Tous" ||
                      message.receiver.value ===
                        (orgData?.id || "particulier") ? (
                      <div
                        className="text-shadow_50 text-h3 group flex flex-col"
                        key={index}
                      >
                        {message.file?.url ? (
                          <div
                            onClick={() => handleDownloadFile(message)}
                            className="flex flex-row gap-2 mr-auto  max-w-60  cursor-pointer  text-violet-500 rounded-md w-fit "
                          >
                            <Tippy
                              content="Télécharger le fichier"
                              className="custom-tooltip"
                              delay={500}
                            >
                              <div className="flex flex-col">
                                <div className="text-h3 flex flex-row justify-center items-center gap-3 hover:font-medium text-wrap text-indigo-500 bg-indigo-100 rounded-xl p-3">
                                  {loadingDownloadFile === message.id ? (
                                    <SmallSpinner></SmallSpinner>
                                  ) : (
                                    <Icon1
                                      icon_name="file"
                                      fill="#6366f1"
                                      size={25}
                                    ></Icon1>
                                  )}
                                  <div className="flex flex-col ">
                                    <div className="text-h3">
                                      {message.file?.name.length > 20
                                        ? message.file?.name.substring(0, 20) +
                                          "..."
                                        : message.file?.name}
                                    </div>
                                    <div className="text-h5 text-shadow_50">
                                      {
                                        // file size in kB
                                        Math.round(message.file?.octets / 1000)
                                      }{" "}
                                      Ko
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Tippy>
                          </div>
                        ) : message.img_file?.url ? (
                          <div
                            onClick={() => handleDownloadFile(message)}
                            className="flex flex-row relative gap-2 mr-auto cursor-pointer hover:max-w-full duration-1000 transition-all max-w-60 p-2  w-fit   "
                          >
                            {loadingDownloadFile === message.id && (
                              <div className="absolute top-2 left-2 z-10 p-2 bg-wshadow_25 backdrop-blur-md border-white border- rounded-md">
                                <SmallSpinner></SmallSpinner>
                              </div>
                            )}
                            <Tippy
                              content="Télécharger l'image"
                              className="custom-tooltip"
                              delay={500}
                            >
                              <div className="flex flex-col">
                                <img
                                  src={message.img_file.url}
                                  className=" max-h-c150  min-w-full hover:max-h-full duration-1000 transition-all rounded-xl"
                                ></img>
                              </div>
                            </Tippy>
                          </div>
                        ) : (
                          <div
                            className={`flex flex-row gap-2 mr-auto ${can_go_folder ? "max-w-c500" : "max-w-60"} min-w-0 p-3 bg-white text-black rounded-3xl w-fit rounded-tl-none`}
                          >
                            <div className="flex flex-col min-w-0">
                              <div
                                className="text-h3 text-wrap whitespace-pre-wrap break-words"
                                style={{
                                  overflowWrap: "anywhere",
                                  wordBreak: "break-word",
                                }}
                              >
                                {message.content}
                              </div>
                            </div>
                          </div>
                        )}
                        <div className=" pl-2  ml-2 flex  scale-0 p-0 group-hover:p-1  opacity-0 pointer-events-none transition-all duration-300 group-hover:opacity-100 group-hover:scale-100 group-hover:pointer-events-auto rounded-sm flex-row gap-2 text-h5 w-fit mr-auto text-right">
                          {(index === 0 || message.author_id !== messages[index - 1]?.author_id) && (
                            <div className="flex flex-row gap-2">
                              <div className="font-semibold">
                                {getOrgName(message.author_id) === orgData?.name
                                  ? ""
                                  : getOrgName(message.author_id)}
                              </div>{" "}
                              <div className="text-shadow_50  ">
                                {message.sender_user_name || "Inconnu"}
                              </div>
                            </div>
                          )}

                          <div className="text-shadow_50 ">
                            {getTimeString(message.post_date.seconds)}
                          </div>

                          {!can_go_folder && (
                            <div
                              onClick={() => handleSendDropZoneFile(message)}
                              className="cursor-pointer"
                            >
                              {message.file?.url && (
                                <Icon1
                                  icon_name="cloud"
                                  height="16px"
                                  width="16px"
                                  fill="grey"
                                ></Icon1>
                              )}
                            </div>
                          )}
                        </div>
                        {(() => {
                          const readByOrgs = getReadByOrgs(message, true);
                          if (readByOrgs.length > 0) {
                            return (
                              <div className="text-h5 text-shadow_50 mr-auto text-left mt-1 pl-2">
                                Lu par:{" "}
                                {readByOrgs
                                  .map(
                                    (item) =>
                                      `${readByNames[item.orgId] || "..."} (${formatReadTime(item.readTime)})`
                                  )
                                  .join(", ")}
                              </div>
                            );
                          }
                          return null;
                        })()}
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              ))}
          </div>
          <div className="absolute bottom-0 items-end  w-full flex flex-col">
            {(can_go_folder ||
              folder.notified_orgs_id?.filter(
                (org_id) => org_id === (orgData?.id || "particulier")
              ).length > 0) && (
              <div className=" bg-wshadow_25 flex flex-row gap-2  w-fit backdrop-blur-md rounded-tl-lg p-3 border border-white">
                {can_go_folder && (
                  <SecondaryButton className="w-fit" onClick={handleGoFolder}>
                    Aller au dossier
                  </SecondaryButton>
                )}
                {folder.notified_orgs_id?.filter(
                  (org_id) => org_id === (orgData?.id || "particulier")
                ).length > 0 &&
                  messageNotRead && (
                    <div className="h-full w-full inset-0  animate-tiny-bounce hover:animate-none  shadow-none flex flex-row gap-2 items-center">
                      <PrimaryButton
                        className="w-fit"
                        onClick={handleSetMessagesRead}
                      >
                        Marquer comme lu
                      </PrimaryButton>
                    </div>
                  )}
              </div>
            )}
            <div className="rounded-b-xl bg-white  flex w-full  max-h-fit  flex-col  border-1 border-shadow_10">
              <div className="flex flex-row h-fit">
                <div className="flex flex-col p-2 w-full h-fit">
                  <TextFieldChat
                    value={message_value}
                    onChange={(e) => setMessageValue(e.target.value)}
                    setSelectedOption={handleSetOption}
                    options={receiver_options}
                  />
                </div>
              </div>
              <Divider orientation="horizontal" />
              {dragging && (
                <>
                  <div className="h-full w-full animate-shimmer rounded-xl shadow-none">
                    <PrimaryButton
                      className="h-full w-full animate-shimmer rounded-2xl"
                      onClick={handleSendFileFU}
                    >
                      Transférer ici
                    </PrimaryButton>
                  </div>
                  <Divider orientation="horizontal" />
                </>
              )}
              <div className="flex flex-row  h-fit p-1">
                <div
                  onClick={() => setMessageValue(message_value + "@")}
                  className="cursor-pointer flex flex-row bg-indigo-50 border hover:scale-105 text-h3 items-center text-indigo-500 font-normal px-2 py-0.5 bg-bl rounded-2xl"
                >
                  <Icon1 icon_name="email" size={16} fill={"#6366f1"}></Icon1>
                  {receiver?.name}
                </div>
              </div>
              <div className="flex flex-row gap-2 h-fit px-1">
                <Tippy
                  content="Envoyer un fichier"
                  className="custom-tooltip"
                  delay={500}
                >
                  <div className="cursor-pointer" onClick={handleSendFile}>
                    <Icon1
                      icon_name="join"
                      height="20px"
                      width="20px"
                      hover_color={"black"}
                      fill={theme.palette.shadow._50}
                    ></Icon1>
                  </div>
                </Tippy>
                <Tippy
                  content="Envoyer une image"
                  className="custom-tooltip"
                  delay={500}
                >
                  <div className="cursor-pointer" onClick={handleSendImage}>
                    <Icon1
                      icon_name="image"
                      height="20px"
                      width="20px"
                      hover_color={"black"}
                      fill={theme.palette.shadow._50}
                    ></Icon1>
                  </div>
                </Tippy>
                <Tippy
                  content="Afficher les ids"
                  className="custom-tooltip"
                  delay={500}
                >
                  <div
                    onClick={() => setMessageAdmin(!messageAdmin)}
                    className=" cursor-pointer"
                  >
                    <Icon1
                      icon_name="settings"
                      hover_color={"black"}
                      size={18}
                      fill="grey"
                    ></Icon1>
                  </div>
                </Tippy>
                <div className="flex flex-row w-full justify-end mb-2">
                  <PrimaryButton
                    disabled={message_value.length === 0}
                    onClick={handleSendMessage}
                  >
                    Envoyer
                  </PrimaryButton>
                </div>
              </div>
              {loading_sending && (
                <div className="flex flex-row gap-2 h-fit px-2 text-h3 items-center text-shadow_50">
                  Envoi de l'email en cours ...{" "}
                  <SmallSpinner loading={true} size={15} />
                </div>
              )}
            </div>{" "}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FolderChat;
